(function () {
  // every section includes this file; run it once
  if (window.__mmAbout) return;
  window.__mmAbout = true;
  function initAbout(root) {
    if (!root || root.dataset.mmReady) return;
    root.dataset.mmReady = '1';
    var ac = new AbortController();
    root._mmAbort = ac;
    var opt = { signal: ac.signal };
    var passive = { passive: true, signal: ac.signal };
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    // scroll reveal (everything stays visible in the theme editor)
    root.classList.add('mm-js');
    var revealEls = root.querySelectorAll('.reveal');
    if (!designMode && !reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
      ac.signal.addEventListener('abort', function () { io.disconnect(); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* Journey: on large screens the section pins and vertical scrolling walks the
       track sideways. Smaller or short screens get a swipeable row / vertical list. */
    // Visit: hovering (or tabbing to) a showroom shows its photo; leaving the list restores the main one
    var media = root.querySelector('[data-store-media]');
    if (media) {
      var layers = media.querySelectorAll('[data-store-img]');
      var showStore = function (id) {
        layers.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-store-img') === id); });
      };
      root.querySelectorAll('[data-store]').forEach(function (row) {
        var id = row.getAttribute('data-store');
        row.addEventListener('mouseenter', function () { showStore(id); }, opt);
        row.addEventListener('focusin', function () { showStore(id); }, opt);
      });
      var list = root.querySelector('.stores');
      if (list) {
        list.addEventListener('mouseleave', function () { showStore(null); }, opt);
        list.addEventListener('focusout', function (e) { if (!list.contains(e.relatedTarget)) showStore(null); }, opt);
      }
    }

    var journey = root.querySelector('[data-journey]');
    if (!journey) return;
    var jViewport = journey.querySelector('[data-journey-viewport]');
    var jTrack = journey.querySelector('[data-journey-track]');
    var jProgress = journey.querySelector('[data-journey-progress]');
    var jDistance = 0;

    var jPin = journey.querySelector('.journey-pin');
    var jInner = journey.querySelector('.journey-inner');
    var pinTop = 0;
    // height of the theme's fixed/sticky header, so the pinned timeline sits below it
    function headerOffset() {
      var h = 0;
      document.querySelectorAll('header, [id*="header" i], [class*="header" i]').forEach(function (el) {
        if (root.contains(el)) return;
        var cs = getComputedStyle(el);
        if ((cs.position === 'fixed' || cs.position === 'sticky') && cs.display !== 'none' && el.offsetHeight < 240) h = Math.max(h, el.offsetHeight);
      });
      return h;
    }
    // position:sticky fails inside an overflow:hidden/auto ancestor. Theme wrappers that only clip
    // (not real scrollers) are switched to overflow:clip, which looks the same but lets sticky work.
    function unblockSticky() {
      for (var el = journey.parentElement; el && el !== document.body; el = el.parentElement) {
        var cs = getComputedStyle(el);
        if (!/(auto|scroll|hidden)/.test(cs.overflowX + ' ' + cs.overflowY)) continue;
        var scrolls = /(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1;
        if (scrolls || cs.overflowX === 'scroll' || cs.overflowY === 'scroll') return false;
        el.style.overflowX = cs.overflowX === 'visible' ? 'visible' : 'clip';
        el.style.overflowY = cs.overflowY === 'hidden' ? 'clip' : 'visible';
        if (getComputedStyle(el).overflowX !== el.style.overflowX) return false; // browser without overflow:clip
      }
      return true;
    }
    // desktop/laptop get the scroll-driven timeline; if it is taller than the space under
    // the header it is scaled down to fit (down to 0.8, below that it is not pinned)
    function fitScale() {
      journey.style.setProperty('--jz', 1);
      var cs = getComputedStyle(jPin);
      var need = jInner.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      var avail = window.innerHeight - pinTop;
      journey.style.setProperty('--jz', Math.min(1, (avail - 24) / need).toFixed(3)); // 24px breathing room inside the frame
    }
    function canPin() { return !reduceMotion && !designMode && window.innerWidth > 960 && unblockSticky(); }
    function updateJourney() {
      var p = 0;
      if (journey.classList.contains('is-pinned')) {
        var travel = journey.offsetHeight - (window.innerHeight - pinTop);
        if (travel > 0) p = Math.min(1, Math.max(0, (pinTop - journey.getBoundingClientRect().top) / travel));
        jTrack.style.transform = 'translate3d(' + (-p * jDistance) + 'px,0,0)';
      } else if (jDistance > 0) {
        p = jViewport.scrollLeft / jDistance;
      }
      jProgress.style.transform = 'scaleX(' + p + ')';
    }
    function layoutJourney() {
      jTrack.style.transform = '';
      pinTop = headerOffset();
      journey.style.setProperty('--pin-top', pinTop + 'px');
      var pinned = canPin();
      journey.classList.toggle('is-pinned', pinned);
      if (pinned) {
        fitScale();
        // too short a screen: scaling below 0.8 makes the text hard to read, so use the
        // unpinned swipe layout (full-size text) instead
        if (parseFloat(journey.style.getPropertyValue('--jz')) < 0.8) {
          pinned = false;
          journey.classList.remove('is-pinned');
        }
      }
      if (!pinned) journey.style.removeProperty('--jz');
      jDistance = Math.max(0, jTrack.scrollWidth - jViewport.clientWidth);
      journey.style.height = pinned ? (window.innerHeight - pinTop + jDistance) + 'px' : '';
      updateJourney();
    }
    // tablets fire resize as the browser toolbar shows/hides; only re-layout on real size changes
    var lastW = window.innerWidth, lastH = window.innerHeight;
    function onResize() {
      if (window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 120) return;
      lastW = window.innerWidth; lastH = window.innerHeight;
      layoutJourney();
    }
    window.addEventListener('scroll', function () { if (journey.classList.contains('is-pinned')) updateJourney(); }, passive);
    jViewport.addEventListener('scroll', updateJourney, passive);
    window.addEventListener('resize', onResize, opt);
    window.addEventListener('load', layoutJourney, opt);
    if (document.fonts) document.fonts.ready.then(function () { if (!ac.signal.aborted) layoutJourney(); });
    layoutJourney();

    // mouse drag for the non-pinned desktop fallback
    var dragX = null, dragStart = 0;
    jViewport.addEventListener('pointerdown', function (e) {
      if (journey.classList.contains('is-pinned') || e.pointerType !== 'mouse' || window.innerWidth <= 960) return;
      dragX = e.clientX; dragStart = jViewport.scrollLeft;
    }, opt);
    window.addEventListener('pointermove', function (e) { if (dragX !== null) jViewport.scrollLeft = dragStart - (e.clientX - dragX); }, opt);
    window.addEventListener('pointerup', function () { dragX = null; }, opt);

    var jDialog = journey.querySelector('[data-journey-dialog]');
    var openBtn = journey.querySelector('[data-journey-open]');
    if (jDialog && openBtn) {
      openBtn.addEventListener('click', function () {
        if (typeof jDialog.showModal === 'function') jDialog.showModal();
        else window.open(jDialog.querySelector('img').src, '_blank');
      }, opt);
      journey.querySelector('[data-journey-close]').addEventListener('click', function () { jDialog.close(); }, opt);
      jDialog.addEventListener('click', function (e) { if (e.target === jDialog) jDialog.close(); }, opt);
    }
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-mm-about]').forEach(initAbout); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mm-about]').forEach(function (root) {
      if (root._mmAbort) root._mmAbort.abort();
    });
  });
})();
